import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { PageSizes } from "../../common/constants";
import { EntityIdObject, EntityObject, SearchPageRequest, SearchPageResult } from "../../common/types";
import {
  CreateUpdateLifeInsuranceTariff,
  CreateUpdateLifeInsuranceTariffGroup,
  LifeInsuranceTariff,
  LifeInsuranceTariffFilterPageRequest,
  LifeInsuranceTariffFilterPageResult,
  LifeInsuranceTariffGroup,
} from "./types";

const FILTER_LIFE_INSURANCE_TARIFF_GROUPS = ApiRequestAdapter.create("/life-insurance-tariff-groups", HttpMethod.GET);
const CREATE_LIFE_INSURANCE_TARIFF_GROUP = ApiRequestAdapter.create("/life-insurance-tariff-groups", HttpMethod.POST);
const UPDATE_LIFE_INSURANCE_TARIFF_GROUP = ApiRequestAdapter.create(
  "/life-insurance-tariff-groups/{0}",
  HttpMethod.PUT,
);
const DELETE_LIFE_INSURANCE_TARIFF_GROUP = ApiRequestAdapter.create(
  "/life-insurance-tariff-groups/{0}",
  HttpMethod.DELETE,
);
const FILTER_LIFE_INSURANCE_TARIFFS = ApiRequestAdapter.create("/life-insurance-tariffs/filter", HttpMethod.POST);
const CREATE_LIFE_INSURANCE_TARIFF = ApiRequestAdapter.create("/life-insurance-tariffs", HttpMethod.POST);
const UPDATE_LIFE_INSURANCE_TARIFF = ApiRequestAdapter.create("/life-insurance-tariffs/{0}", HttpMethod.PUT);
const DELETE_LIFE_INSURANCE_TARIFF = ApiRequestAdapter.create("/life-insurance-tariffs/{0}", HttpMethod.DELETE);

export const lifeInsuranceTariffApi = {
  filterLifeInsuranceTariffGroups: (
    request: SearchPageRequest,
  ): AxiosPromise<SearchPageResult<LifeInsuranceTariffGroup>> => {
    return apiService.get(FILTER_LIFE_INSURANCE_TARIFF_GROUPS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createLifeInsuranceTariffGroup: (
    request: CreateUpdateLifeInsuranceTariffGroup,
  ): AxiosPromise<LifeInsuranceTariffGroup> => {
    return apiService.post(CREATE_LIFE_INSURANCE_TARIFF_GROUP.url, request);
  },
  updateLifeInsuranceTariffGroup: (
    request: EntityObject<CreateUpdateLifeInsuranceTariffGroup>,
  ): AxiosPromise<LifeInsuranceTariffGroup> => {
    return apiService.put(UPDATE_LIFE_INSURANCE_TARIFF_GROUP.getParametrizedUrl(request.id), request.object);
  },
  deleteLifeInsuranceTariffGroup: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_LIFE_INSURANCE_TARIFF_GROUP.getParametrizedUrl(request.id));
  },
  filterLifeInsuranceTariffs: (
    request: LifeInsuranceTariffFilterPageRequest,
  ): AxiosPromise<LifeInsuranceTariffFilterPageResult> => {
    return apiService.post(FILTER_LIFE_INSURANCE_TARIFFS.url, request);
  },
  createLifeInsuranceTariff: (request: CreateUpdateLifeInsuranceTariff): AxiosPromise<LifeInsuranceTariff> => {
    return apiService.post(CREATE_LIFE_INSURANCE_TARIFF.url, request);
  },
  updateLifeInsuranceTariff: (
    request: EntityObject<CreateUpdateLifeInsuranceTariff>,
  ): AxiosPromise<LifeInsuranceTariff> => {
    return apiService.put(UPDATE_LIFE_INSURANCE_TARIFF.getParametrizedUrl(request.id), request.object);
  },
  deleteLifeInsuranceTariff: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_LIFE_INSURANCE_TARIFF.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_LIFE_INSURANCE_TARIFF_QUERY_PARAMS: Required<LifeInsuranceTariffFilterPageRequest> = {
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
  keyword: "",
  groupIds: [],
};
